import { Flex } from 'components/Flex';
import { useFetchJaneByIdDataContext } from 'components/JaneModal/FetchJaneById.data.context';
import { JaneName } from 'components/JaneModal/views/JaneDetailsView/ReviewsTab/ReviewsTab.styled';
import {
  ColorDot,
  TimeWrapper,
  FlexWrapper,
  ActivityContentWrapper,
  TextWrapper,
} from 'pages/LocationSettingsPage/PositionsAllocation/RemovePositionModal/views/JaneModal/JaneDetailsView/ActivityTab/ActivityTab.styled';
import { Fragment, FC } from 'react';
import { SectionDivider } from 'components/ShiftModal/ShiftModal.styled';
import { humanReadableDate } from 'components/JaneModal/JaneModal.constants';
import {
  LoadingWrapper,
  Text,
} from 'pages/LocationSettingsPage/PositionsAllocation/RemovePositionModal/views/JaneModal/JaneDetailsView/GeneralTab/GeneralTab.styled';
import {
  Activity,
  auditEvents,
  getActivityColorByEvent,
} from 'pages/LocationSettingsPage/PositionsAllocation/RemovePositionModal/views/JaneModal/JaneDetailsView/ActivityTab/ActivityTab.types';
import i18next from 'i18next';
import { BKJLoadingSpinner } from '@awais4123/fillify-design-library';
export const ActivityTab: FC = () => {
  const { data, activities } = useFetchJaneByIdDataContext();
  if (!data)
    return (
      <LoadingWrapper>
        <BKJLoadingSpinner variant="Default" />
      </LoadingWrapper>
    );
  const { shorthandName = '' } = data;
  return (
    <Fragment>
      <FlexWrapper>
        <Flex flexDirection="column" width="100%">
          <JaneName>{shorthandName}</JaneName>
          <SectionDivider variant="Thin" />
        </Flex>
        <Flex flexDirection="column" width="100%" gap="32px">
          {activities?.length > 0 ? (
            activities.map((item: Activity) => (
              <ActivityContentWrapper key={item.id}>
                <TimeWrapper>{humanReadableDate(item?.created_at)}</TimeWrapper>
                <Flex gap="6px" width="100%">
                  <ColorDot color={getActivityColorByEvent(item?.event)}>•</ColorDot>
                  <TextWrapper>
                    {auditEvents(item?.event, item?.feedable?.shift_ids[0])}
                  </TextWrapper>
                </Flex>
              </ActivityContentWrapper>
            ))
          ) : (
            <Flex height="581px" justifyContent="center" alignItems="center">
              <Text>{i18next.t('team_member:THERE_IS_NO_ACTIVITY')}</Text>
            </Flex>
          )}
        </Flex>
      </FlexWrapper>
    </Fragment>
  );
};
